import {apiSlice} from "../../app/apiSlice";


export interface IDomaine {
    labels: any;
    id:number,
    idNifi:string,
    statutNifi:string,
    libelle:string,
    description:string,
    zone:string,
    x:number,
    y:number,
    sources:Source[],
    sourcesCount: number
}

export interface IAllDomainesApi {
  data: IDomaine[];
  total: number
}

export interface IAllSourcesApi {
    data:Source[];
    total:number
}

export interface Source {
    id:number,
    idNifi:string,
    statutNifi:string,
    nom:string,
    qname:string,
    description:string,
    createur:string,
    categorie:string,
    dateCreation:string,
    modifierPar:string,
    dateDerniereModif:string,
    squidUri: string,
    x:number,
    y:number,
    guid:string,
    sas:boolean,
    domaine:IDomaine,
    metadonnees:any[],
    espacesDeStockage:any[],
    sourceExterne:boolean,
    icon:any,
    sourceVirtuelle:boolean
}

export interface stateSourceExterne {
    runningCount: number;
    stoppedCount:number;
    invalidCount:number;
    disabledCount:number;
    flowFilesQueued:number;
    bulletins: string[]
}

export interface parametersPaginationSources {
    page: number;
    size: number;
    search?: string;
    sort?: string;
    field?: string;
}

export type IDomainQueryParameters = {
  page: number;
  size: number;
  field:string;
  search: string;
  sort: "ASC" | "DESC";
};

export const stateMessage = (state:stateSourceExterne) => {
    const messages = [];
    if (( state.invalidCount > 0) || state.bulletins.length > 0) {
        messages.push("Erreur")
    }
    if (state.runningCount === 0) {
        messages.push("Source en pause")
    }
    if (
        state.stoppedCount === 0 &&
        state.invalidCount === 0 &&
        state.runningCount > 0) {
            messages.push("Source démarée")
    }
    return messages
};

export const logMessage = (state:stateSourceExterne):string[] => {
    if (state.bulletins.length > 0) {
        return state.bulletins
    }
    return []
}

export const extendedApi = apiSlice.injectEndpoints({
    endpoints: (build => (
        {
            state: build.mutation<stateSourceExterne, {id:number}>({
                query: (data) => `/cds/sources/state/${data.id}`,
            }),
            atlas: build.mutation<any, {type:string}>({
                query: (data) => `/cds/espaces/atlas/${data.type}`,
            }),
            atlasCds: build.query<{nom:string,type:string,guid:string}[], {type:string}>({
                query: (data) => `/cds/espaces/atlas/${data.type}`,
            }),
            sourceNifiCheck: build.mutation<any, {id:number}>({
                query: (data) => `/cds/sources/${data.id}/check`,
            }),
            getAllSources: build.query<IAllSourcesApi, parametersPaginationSources | void>({
                query: (data) => {
                  if(data) {
                    return `/cds/sources?page=${data.page}&size=${data.size}&search=${data.field}:${data.search}&sort=${data.field},${data.sort}`
                  } else {
                    return "/cds/sources"
                  }
                },
            }),
            domaines: build.query<IAllDomainesApi, IDomainQueryParameters | void>({
                query: (data) => {
                  if(data) {
                    return `/cds/domaines?page=${data.page}&size=${data.size}&search=${data.field}:${data.search}&sort=${data.field},${data.sort}`
                  } else {
                    return "cds/domaines"
                  }
                },
                keepUnusedDataFor: 0,
            }),

            checkNifiSynchronisationDomaine: build.mutation<any, {id:number}>({
                query: (data) => ({
                    url: `cds/domaines/${data.id}/check`,
               
                }),
    
            }),
            source: build.query<any, {id:number}>({
                query: (data) => `/cds/sources/${data.id}`,
            }),
            existSource: build.mutation<any, {name:string}>({
                query: (data) => `/cds/sources/count/${data.name}`,
            }),
            viewSource: build.query<any, {id:number}>({
                query: (data) => `/cds/sources/${data.id}/view`,
            }),
            checkSource: build.mutation<any, {id:number}>({
                query: (data) => `/cds/sources/${data.id}/check`,
            }),
            types: build.query<any, void>({
                query: () => `/cds/types`,
            }),
            typesDonnee: build.query<any, void>({
                query: () => `/cds/types-donnee`,
            }),
            protocole: build.query<any, void>({
                query: () => `/cds/protocoles`,
            }),
            
            protocoles: build.mutation<any, void>({
                query: () => `/cds/protocoles`,
            }),
            zones: build.query<string[], void>({
                query: () => `/cds/domaines/zones`,
            }),
            existDomaine: build.mutation<any, {value:string}>({
                query: (data) => `/cds/domaines/count/${data.value}`,
            }),
            addDomaines: build.mutation<any, {libelle:string,description:string,zone:string}>({
                query: (data) => ({
                    url: `/cds/domaines/`, method: 'post', body: {
                        libelle : data.libelle,
                        description : data.description,
                        zone: data.zone
                    }
                }),
    
            }),
            // sources/:id/inscription-squid
            SourceSquid: build.mutation<any, {id:number,uri:string}>({
                query: (data) => ({
                    url: `cds/sources/${data.id}/inscription-squid`, method: 'post', body: data.uri
               
                }),
            }),
            startAndPause: build.mutation<any, {state:string, id : number}>({
                query: (data) => ({
                    url: `cds/sources/start-and-pause/${data.id}`, method: 'put', body: {
                        state : data.state
                    }
               
                }),
            }),

            updateDomaine: build.mutation<any, {domaine:IDomaine}>({
                query: (data) => ({
                    url: `cds/domaines/`, method: 'put', body: data.domaine
               
                }),
            }),
            SourceNifi: build.mutation<any, {id:number,data:any}>({
                query: (data) => ({
                    url: `cds/sources/${data.id}/synchronise`, method: 'post', body: data.data
               
                }),
    
            }),

            SynchroniseDomaineNifi: build.mutation<any, {id:number,domaine:IDomaine}>({
                query: (data) => ({
                    url: `cds/domaines/${data.id}/synchronise`, method: 'post', body: data.domaine
               
                }),
    
            }),

        
            // sources/:id/synchronise
            addSource: build.mutation<any, {description:string,guid:string[],idDomaine:number,metadonnees:any[],motDePasse:string,nom:string,sas:boolean}>({
                query: (data) => ({
                    url: `/cds/sources/`, method: 'post', body: {

                        description : data.description,
                        guidEspaces: data.guid,
                        idDomaine : data.idDomaine,
                        idSourceExternes: [],
                        metadonnees: data.metadonnees,
                        motDePasse: data.motDePasse,
                        nom: data.nom,  
                        sas: data.sas,
                        categorie:"externe"
                    }
                }),
    
            }),
            updateSource:build.mutation<any, {id:number,description:string,guid:string[],idDomaine:number,metadonnees:any[],motDePasse:string,nom:string,sas:boolean}>({
                query: (data) => ({
                    url: `/cds/sources/`, method: 'put', body: {
                        id: data.id,
                        description : data.description,
                        guidEspaces: data.guid,
                        idDomaine : data.idDomaine,
                        idSourceExternes: [],
                        metadonnees: data.metadonnees,
                        motDePasse: data.motDePasse,
                        nom: data.nom,  
                        sas: data.sas,
                        categorie:"externe"
                    }
                }),
    
            }),
            deleteSource:build.mutation<any, {id:number}>({
                query: (data) => ({
                    url: `/cds/sources/${data.id}`, method: 'delete'
                }),
    
            }),

            deleteDomaine:build.mutation<any, {id:number}>({
                query: (data) => ({
                    url: `/cds/domaines/${data.id}`, method: 'delete'
                }),
    
            }),
        }
    )),
    overrideExisting: false
})


export const {
    useZonesQuery,
    useDomainesQuery,
    useTypesQuery,
    useTypesDonneeQuery,
    useProtocoleQuery,
    useProtocolesMutation,
    useAddDomainesMutation,
    useExistDomaineMutation,
    useAddSourceMutation,
    useLazyViewSourceQuery,
    useCheckSourceMutation,
    useExistSourceMutation,
    useSourceQuery,
    useAtlasMutation,
    useSourceNifiCheckMutation,
    useSourceSquidMutation,
    useSourceNifiMutation,
    useUpdateSourceMutation,
    useDeleteSourceMutation,
    useStartAndPauseMutation,
    useStateMutation,
    useDeleteLabelNodeMutation,
    useSynchroniseDomaineNifiMutation,
    useCheckNifiSynchronisationDomaineMutation,
    useUpdateDomaineMutation,
    useDeleteDomaineMutation,
    useAtlasCdsQuery,
    useGetAllSourcesQuery
} = extendedApi